import { aiAndAgentPages } from './aiAgentPages';

export const pages = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    title: 'Dashboard',
    description: 'Review the latest admin metrics, exam activity, and platform health in one overview.',
  },
  {
    id: 'platform-operations',
    label: 'Operations',
    title: 'Platform operations',
    description: 'Monitor async admin jobs, queue depth, dead-letter backlog, and worker retry paths.',
  },
  { id: 'version', label: 'Version', title: 'Version', description: 'Review deployment version, service build metadata, deployment time, and connector health.' },
  {
    id: 'billing',
    label: 'Subscriptions',
    title: 'Subscriptions',
    description: 'Manage subscribers, subscription policy, coupons, trials, recovery workflows, and provider event processing.',
    children: [
      { id: 'billing-overview', label: 'Dashboard', title: 'Subscription dashboard', description: 'Monitor subscription growth, cancellations, failed payments, and operational health.' },
      { id: 'billing-customers', label: 'Subscribers', title: 'Subscribers', description: 'Find a payer account and manage every subscription linked to that customer.' },
      { id: 'billing-subscriptions', label: 'Subscriptions', title: 'Subscription control', description: 'Review subscriptions, provider portal sessions, and cancellation support state.' },
      { id: 'billing-coupons', label: 'Coupons & trials', title: 'Coupons & trials', description: 'Manage provider-neutral discount campaigns, trial campaigns, and redemption policy.' },
      { id: 'billing-webhooks', label: 'Provider events', title: 'Provider events', description: 'Trace provider webhook and outbox processing to the affected customer or subscription.' },
    ],
  },
  {
    id: 'curriculums',
    label: 'Curriculum',
    title: 'Curriculum',
    description: 'Browse, review, and launch the curriculum workspaces available to learners.',
  },
  {
    id: 'curriculum',
    label: 'Curriculum',
    title: 'Curriculum workspace',
    description: 'View and edit the selected curriculum structure, metadata, and linked content.',
    hidden: true,
  },
  {
    id: 'topics',
    label: 'Topics',
    title: 'Topics',
    description: 'Browse, review, and launch topic workspaces for curriculum content.',
  },
  {
    id: 'topic',
    label: 'Topic',
    title: 'Topic workspace',
    description: 'View and edit the selected topic structure, metadata, and linked content.',
    hidden: true,
  },
  {
    id: 'sub-topic',
    label: 'Units',
    title: 'Units',
    description: 'Browse and manage units by topic, status, exercise coverage, and order.',
  },
  {
    id: 'questions',
    label: 'Questions',
    title: 'Questions',
    description: 'Browse reusable questions by topic and unit for mock exam generation.',
  },
  {
    id: 'question',
    label: 'Question',
    title: 'Question workspace',
    description: 'Create and edit a reusable question attached to a topic and unit.',
    hidden: true,
  },
  {
    id: 'question-review',
    label: 'Question review',
    title: 'Question Bank review',
    description: 'Review and edit a bounded, filtered page of reusable question details.',
    hidden: true,
  },
  {
    id: 'unit',
    label: 'Unit',
    title: 'Unit workspace',
    description: 'Create and edit a unit, its media, ordering, and publication state.',
    hidden: true,
  },
  {
    id: 'mock-exams',
    label: 'Mock exams',
    title: 'Mock exams',
    description: 'Browse, review, and launch mock exam workspaces for assessment management.',
  },
  {
    id: 'predicted-papers',
    label: 'Predicted papers',
    title: 'Predicted papers',
    description: 'Browse, create, and manage predicted paper workspaces separately from mock exams.',
  },
  {
    id: 'predicted-paper',
    label: 'Predicted paper',
    title: 'Predicted paper workspace',
    description: 'View and edit the selected predicted paper structure, questions, and metadata.',
    hidden: true,
  },
  {
    id: 'mock-exam',
    label: 'Mock exam',
    title: 'Mock exam workspace',
    description: 'View and edit the selected mock exam structure, questions, and metadata.',
    hidden: true,
  },
  {
    id: 'users',
    label: 'Users & roles',
    title: 'Users & roles',
    description: 'Browse, review, and launch user workspaces for account and access management.',
  },
  {
    id: 'academic-year',
    label: 'Academic year',
    title: 'Academic year',
    description: 'Set the recurring organization-wide academic-year boundary used for learner placement and progression.',
  },
  {
    id: 'profile',
    label: 'Profile',
    title: 'Profile',
    description: 'Manage your admin profile, display name, login details, and avatar.',
    hidden: true,
  },
  {
    id: 'user',
    label: 'User',
    title: 'User workspace',
    description: 'View and edit the selected user account, role, and curriculum access.',
    hidden: true,
  },
  {
    id: 'roles',
    label: 'Roles',
    title: 'Role admin',
    description: 'Create, rename, and remove platform roles.',
    hidden: true,
  },
  ...aiAndAgentPages,
  {
    id: 'analytic',
    label: 'Analytic',
    title: 'Analytic',
    description: 'Review exam scores, time spent, and learner performance trends.',
    hidden: true,
  },
  {
    id: 'analytics',
    label: 'Analytics',
    title: 'Learner analytics',
    description: 'Compare learner exam counts and completion progress.',
  },
  {
    id: 'report',
    label: 'Report',
    title: 'Report',
    description: 'Review the selected learner exam report and answer breakdown.',
    hidden: true,
  },
];
